import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CommonService } from '../../../../services/common';
import { SalesService } from '../../sales.service';

@Component({
  selector: 'app-client-market-outstanding-ageing',
  templateUrl: './client-market-outstanding-aging.component.html',
  styleUrl: './client-market-outstanding-aging.component.scss'
})
export class ClientMarketOutstandingAgeingComponent implements OnInit, OnChanges {

  private destroy$ = new Subject<void>();
  outstandingList: any;

  ageingBuckets: any
  //To capture total of entire sale but ageing bucket wise of all Clients
  ageingBucketsTotals: any = {}

  clientList: any
  clientOutstandingData: any[] = [];
  tempclientOutstandingData: any = {};

  saleReportRequest: any = {}
  totalAmountOutstanding: any = 0

  constructor(public commonService: CommonService, private saleService: SalesService) { }

  ngOnInit(): void {
    this.getSaleReportDate();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }


  getSaleReportDate() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
        this.resetAllTotals()
        //project ids has tp go in array as for admin view we may need report for all in single view
        this.saleReportRequest.projectId = [selectedProject?.id]

        this.saleService.getClientWiseOutstandingAgeing(this.saleReportRequest).subscribe(res => {
          if (res != null && res?.result.length > 0) {
            this.outstandingList = res?.result;
            //Get unique Ageing buckets to decide columns to create for agign bucket
            this.ageingBuckets = this.commonService.getDistinctKeyValueFromArray(this.outstandingList, 'ageingBucketName');

            //Get list of unique Clients so that 
            this.clientList = this.commonService.getDistinctKeyValueFromArray(this.outstandingList, 'clientId');

            this.clientList.forEach((client: any) => {
              this.tempclientOutstandingData = {}
              //We will add only that agent to list whose client's amount is pending in any ageing bucket
              var currentclientOutstandingData = this.outstandingList.filter((x: any) => x.clientId == client && (x.amountDue > 0));
              if (currentclientOutstandingData.length > 0) {
                this.tempclientOutstandingData = {
                  "clientId": client,
                  "clientName": currentclientOutstandingData[0]?.clientName
                }

                //Now we need to prepare data of that agent for all bucket fetched above. 
                // if none of his client then he will not be shown 
                this.ageingBuckets.forEach((bucket: any) => {
                  //check if any outstanding in current ageing bucket
                  var outStandingInCurrAgeing = currentclientOutstandingData.filter((x: any) => x.ageingBucketName == bucket)
                  if (outStandingInCurrAgeing.length > 0) {
                    this.tempclientOutstandingData[bucket] = {
                      "ageingDateRange": outStandingInCurrAgeing[0]?.ageingDateRange,
                      "amountOutstanding": outStandingInCurrAgeing[0].amountDue?.toLocaleString('en-IN'),
                    }

                    this.totalAmountOutstanding = (this.totalAmountOutstanding != undefined ? this.totalAmountOutstanding : 0) + outStandingInCurrAgeing[0]?.amountDue
                  }
                  else {
                    this.tempclientOutstandingData[bucket] = {
                      "amountOutstanding": 0,
                    }
                  }

                  this.ageingBucketsTotals[bucket] =
                  {
                    //for consicutive ittrations of ageing loop. Also will not reset for each agent as it will have total of 
                    //entire sales for all ageing buckets 
                    "TotalAmountDue": (!this.commonService.isNullUndefined(this.ageingBucketsTotals[bucket]?.TotalAmountDue) ? this.ageingBucketsTotals[bucket]?.TotalAmountDue : 0) +
                      (!this.commonService.isNullUndefined(outStandingInCurrAgeing[0]?.amountDue) ? outStandingInCurrAgeing[0]?.amountDue : 0)
                  }
                })//end of ageing bucket loop
                this.clientOutstandingData.push(this.tempclientOutstandingData)
              }//end of if agent has made any sale condition
            })//end of agent list loop

            ///run loop again for ageing bucket to format the amount. earlier could not do since that was being used in calculation
            this.ageingBuckets.forEach((bucket: any) => {
              this.ageingBucketsTotals[bucket].TotalAmountDue = this.ageingBucketsTotals[bucket].TotalAmountDue?.toLocaleString('en-IN')
            });
          }
        })
      })
  }


  resetAllTotals() {
    this.ageingBucketsTotals = []
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
